<template>
    <div>
      
        <h2 class="ix-page-title-secondary mt-4">Contenu</h2>
        <div class="row">
            <div class="col-sm-12 col-md-6" v-if="model == 'quote'">
                 <div class="form-group row">
                    <label class="col-sm-4 col-form-label">TVA globale à appliquer</label>
                    <div class="input-group mb-3 col-sm-8">
                        <input type="number" class="form-control" v-model="globalTva" id="global_tva" name="global_tva" step="0.01" placeholder="TVA globale"/>
                        <div class="input-group-append">
                            <span class="input-group-text" id="basic-addon2">%</span>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                        <tr>
                            <th style="width: 30px;"></th>
                            <th style="width: 30px;">
                                <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                            </th>
                            <th style="width: 150px;">Référence</th>
                            <th>Désignation</th>
                            <th style="width: 120px;">Qté</th>
                            <th class="text-right" style="width: 180px;">P.U. HT</th>
                            <th class="text-center" style="width: 120px;">Remise</th>
                            <th class="text-right" style="width: 180px;">Total H.T.</th>
                            <th class="text-center" style="width: 120px;" v-if="isAutoliquidation != 1">Tva</th>
                            <th style="width: 120px;"></th>
                        </tr>
                        </thead>
                        <draggable v-model="lines" tag="tbody" handle=".handle-line" v-if="!loading" @end="moveLine">
                            <tr v-for="(line, index) in lines" is="line-form"
                                v-bind:key="line.uniq"
                                :line="line"
                                :index="index"
                                :discount="discount"
                                :isAutoliquidation="isAutoliquidation"
                                :suggestionsRoute="suggestionsRoute"
                                :model="model"
                                :id="id"
                                :tva="globalTva"
                                :editable="editable"
                                :can-hide="hideableLineUniqs[line.uniq] === true"
                                :shows-hidden-flag="hiddenLinesEnabled === false && line.is_hidden_from_client == 1"
                                :is-protected-article="protectedArticleLineUniqs[line.uniq] === true"
                                :options-enabled="optionsEnabled"
                                v-on:line-editing-started="checkIfNewRowNeeded($event)"
                                v-on:line-deleted="deleteRow($event)"
                                v-on:line-under-total-edited="computeUnderTotalLine($event)"
                                v-on:add-eco-line="addEcoLine($event)"
                                v-on:remove-eco-lines-for-article="removeEcoLinesForArticle($event)"
                                v-on:update-eco-lines-quantity="updateEcoLinesQuantity($event)"
                                v-on:line-toggle-optional="toggleLineOptional($event)"
                            ></tr>
                        </draggable>
                        <tr v-if="loading">
                            <td colspan="9" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                    </table>
                </div>

                <button type="button" class="ix-btn link" :disabled="editable ? false : true" @click="addRow(null)"><i class="far fa-plus"></i> Nouvelle ligne</button>
                <div>

                <button type="button" class="ix-btn link" @click="addUnderTotalRow(null)" :disabled="!can_add_line_under_total || (editable ? false : true)"><i class="far fa-plus"></i> Nouveau sous-total</button>
                </div>
            </div>
        </div>

        <div class="row mb-4 mt-2" v-if="!loading">
            <div class="col-sm-12 col-md-12 col-lg-4 offset-lg-8">
                <div class="ix-trade-totals">
                    <table class="ix-table ix-table-transparent">
                        <tbody>
                        <tr>
                            <td>Total HT</td>
                            <td class="text-right">{{ currency(total_ht) }}</td>
                        </tr>
                        <tr>
                            <td>
                                Remise globale
                                <div class="input-group input-group-sm" style="width: 120px;">
                                    
                                    <input type="number" class="form-control text-center" name="discount" v-model="discount" required min="0" id="discount" :disabled="editable ? false : true" step="0.001">
                                    <input type="hidden" class="form-control text-center" name="discount" v-model="discount" required min="0" id="discount" v-if="editable ? false : true" step="0.001">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">- {{ currency(total_discount) }}</td>
                        </tr>
                        <tr>
                            <td class="ix-text-bold">
                                Net commercial
                            </td>
                            <td class="text-right">
                                <span class="ix-text-bold ix-text-xlarge">{{ currency(total_after_discount) }}</span>
                            </td>
                        </tr>
                        <tr v-if="total_eco_participation != 0">
                            <td>Éco-participation</td>
                            <td class="text-right">{{ currency(total_eco_participation) }}</td>
                        </tr>
                        <tr>
                            <td>
                                Total TVA
                                <div>
                                    <span class="ix-text-bold">Autoliquidation</span>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_false" value="0" v-model="isAutoliquidation" :disabled="editable ? false : true">
                                        <label class="form-check-label" for="is_autoliquidation_false">Non</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_true" value="1" v-model="isAutoliquidation" :disabled="editable ? false : true">
                                        <label class="form-check-label" for="is_autoliquidation_true">Oui</label>
                                    </div>

                                    <input type="hidden" class="form-control text-center" name="is_autoliquidation" v-model="isAutoliquidation"  id="discount" v-if="editable ? false : true">
                                </div>
                            </td>
                            <td class="text-right">{{ currency(total_vat) }}</td>
                        </tr>
                        <tr>
                            <td>Total TTC</td>
                            <td class="text-right">{{ currency(total_ttc) }}</td>
                        </tr>
                        <template v-if="has_optional_lines">
                            <tr class="ix-line-optional">
                                <td>Options HT</td>
                                <td class="text-right">{{ currency(total_optional_ht) }}</td>
                            </tr>
                            <template v-if="isAutoliquidation != 1">
                                <tr class="ix-line-optional">
                                    <td>TVA options</td>
                                    <td class="text-right">{{ currency(total_optional_vat) }}</td>
                                </tr>
                                <tr class="ix-line-optional">
                                    <td>Options TTC</td>
                                    <td class="text-right">{{ currency(total_optional_ttc) }}</td>
                                </tr>
                            </template>
                            <tr>
                                <td class="ix-text-bold">Total {{ isAutoliquidation == 1 ? 'HT' : 'TTC' }} avec options</td>
                                <td class="text-right ix-text-bold">{{ currency(isAutoliquidation == 1 ? total_after_discount + total_eco_participation + total_optional_ht : total_ttc + total_optional_ttc) }}</td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LineForm from "./LineForm";
    import draggable from 'vuedraggable';

    export default {
        name: 'line-table-form',
        props: ['suggestionsRoute', 'oldLines', 'oldAutoliquidation', 'oldDiscount', 'model', 'id', 'tvaGlobal', 'isEditable', 'lotMainStyle', 'lotDetailStyle', 'hiddenLinesEnabled', 'optionsEnabled'],
        components : {
            LineForm,
            draggable
        },
        data() {
            return {
                loading: true,
                discount: 0,
                isAutoliquidation: 0,
                lines: [],
                globalTva: this.tvaGlobal,
                editable: true,
            };
        },
        computed: {
            // Les options d'un devis sont chiffrées à part, hors des totaux
            baseLines: function() {
                return this.lines.filter(line => !line.is_optional);
            },
            optionalLines: function() {
                return this.lines.filter(line => line.is_optional && !line.is_title);
            },
            has_optional_lines: function() {
                return this.model == 'quote' && this.optionalLines.length > 0;
            },
            total_ht: function() {
                var sum = 0;
                this.baseLines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_ht) || 0;
                });
                return sum;
            },
            total_eco_participation: function() {
                var sum = 0;
                this.baseLines.forEach(line => {
                    if (line.is_eco_participation) sum += parseFloat(line.total_ht) || 0;
                });
                return sum;
            },
            total_discount: function() {
                var sum = 0;
                this.baseLines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_discount) || 0;
                });
                return sum;
            },
            total_after_discount: function() {
                var sum = 0;
                this.baseLines.forEach(line => {
                    if (!line.is_eco_participation) sum += parseFloat(line.total_after_discount) || 0;
                });
                return sum;
            },
            total_vat: function() {
                var sum = 0;
                this.baseLines.forEach(line => sum += line.total_vat);
                return Math.round(sum * 100) / 100;
            },
            total_ttc: function() {
                var sum = 0;
                this.baseLines.forEach(line => sum += line.total_ttc);
                return Math.round(sum * 100) / 100;
            },
            total_optional_ht: function() {
                var sum = 0;
                this.optionalLines.forEach(line => sum += parseFloat(line.total_after_discount) || 0);
                return Math.round(sum * 100) / 100;
            },
            total_optional_vat: function() {
                var sum = 0;
                this.optionalLines.forEach(line => sum += parseFloat(line.total_vat) || 0);
                return Math.round(sum * 100) / 100;
            },
            total_optional_ttc: function() {
                var sum = 0;
                this.optionalLines.forEach(line => sum += parseFloat(line.total_ttc) || 0);
                return Math.round(sum * 100) / 100;
            },
            can_add_line_under_total: function(){
                var can = false;
                can = this.lines.filter((element) => element.amount != 0).length > 0 ? true : false;
                return can;
            },
            hideableLineUniqs: function() {
                var hideable = {};
                var lotMainStyle = parseInt(this.lotMainStyle);
                if (this.model != 'quote' || !lotMainStyle || this.hiddenLinesEnabled === false) {
                    return hideable;
                }

                var inLotDetail = false;
                this.lines.forEach(line => {
                    var isTitle = line.is_title == 1;
                    if (parseInt(line.line_type_style) === lotMainStyle) {
                        inLotDetail = !isTitle;
                        return;
                    }

                    var isUnderTotal = !!parseFloat(line.under_total);
                    var isEcoParticipation = line.is_eco_participation == 1;
                    if (inLotDetail && isTitle && !isUnderTotal && !isEcoParticipation) {
                        hideable[line.uniq] = true;
                    }
                });

                return hideable;
            },
            protectedArticleLineUniqs: function() {
                var parentIds = {};
                var parentUniqs = {};
                this.lines.forEach(line => {
                    if (line.is_eco_participation == 1) {
                        if (line.eco_parent_line_id) {
                            parentIds[line.eco_parent_line_id] = true;
                        }
                        if (line.eco_parent_uniq) {
                            parentUniqs[line.eco_parent_uniq] = true;
                        }
                    }
                });

                var lotMainStyle = parseInt(this.lotMainStyle);
                var lotDetailStyle = parseInt(this.lotDetailStyle);
                var inPricedLot = false;
                var protectedLines = {};
                this.lines.forEach(line => {
                    var isEcoParticipation = line.is_eco_participation == 1;
                    if (lotMainStyle && parseInt(line.line_type_style) === lotMainStyle) {
                        inPricedLot = line.is_title != 1;
                        return;
                    }

                    var isEcoParent = !isEcoParticipation && ((line.id && parentIds[line.id]) || parentUniqs[line.uniq]);
                    var isLotDetailArticle = inPricedLot && lotDetailStyle && line.is_title != 1 && !isEcoParticipation
                        && parseInt(line.line_type_style) === lotDetailStyle && !parseFloat(line.amount) && line.article_id;

                    if (isEcoParent || isLotDetailArticle) {
                        protectedLines[line.uniq] = true;
                    }
                });

                return protectedLines;
            }
        },
        methods : {
            addRow: function (line) {
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 0,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    amount: 0,
                    discount: 0,
                    vat: this.isAutoliquidation == 0 ? this.globalTva : 0,
                    total_ht: 0,
                    total_discount: 0,
                    total_after_discount: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    under_total: null,
                    article_id: null,
                    parent_id: null,
                    line_type_style: null,
                    is_hidden_from_client: false,
                    // Champs éco-participation
                    is_eco_participation: false,
                    eco_category_id: null,
                    eco_parent_line_id: null,
                    eco_parent_uniq: null,
                    eco_rate_amount: null,
                    eco_unit_amount: null,
                    is_optional: false
                }

                if (line != null) {
                    const isEcoParticipation = line.is_eco_participation === true || line.is_eco_participation === 1 || line.is_eco_participation === '1'
                    data.id = line.id
                    data.is_title = line.is_title
                    data.reference = line.reference
                    data.designation = line.designation
                    data.description = line.description
                    data.quantity = line.quantity
                    data.amount = line.amount
                    data.unit = line.unit
                    data.discount = line.discount
                    data.vat = line.vat
                    data.under_total = line.under_total,
                    data.article_id  = line.article_id
                    data.parent_id = line.parent_id
                    data.line_type_style = line.line_type_style || null
                    data.is_hidden_from_client = line.is_hidden_from_client == 1
                    data.is_optional = line.is_optional === true || line.is_optional === 1 || line.is_optional === '1'
                    // Champs éco-participation
                    data.is_eco_participation = isEcoParticipation
                    data.eco_category_id = line.eco_category_id || null
                    data.eco_parent_line_id = line.eco_parent_line_id || null
                    data.eco_parent_uniq = line.eco_parent_uniq || null
                    data.eco_rate_amount = line.eco_rate_amount || null
                    data.eco_unit_amount = line.eco_unit_amount || null

                    if (data.is_eco_participation && data.eco_unit_amount === null) {
                        data.eco_unit_amount = parseFloat(line.amount) || 0
                    }
                }

                this.lines.push(data)
            },
            addUnderTotalRow(){
                var data = {
                    id: null,
                    uniq: Math.random().toString(36).substr(2, 9),
                    is_title: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    amount: 0,
                    discount: 0,
                    vat: this.isAutoliquidation == 0 ? this.globalTva : 0,
                    total_ht: 0,
                    total_discount: 0,
                    total_after_discount: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    under_total: 0,
                }

                var sum = 0;

                this.lines.forEach(line => {{
                    if(line.is_title && line.under_total && line.under_total != null)
                        sum = 0
                    else    
                        sum += parseFloat(line.total_after_discount);
                }})

                data.under_total = sum;
                data.designation = 'Sous total HT : ' + this.currency(sum)

                this.lines.push(data);
            },
            deleteRow: function (index) {
                const lineToDelete = this.lines[index];
                
                // Si on supprime une ligne article, supprimer ses lignes éco
                if (!lineToDelete.is_eco_participation && lineToDelete.article_id) {
                    this.removeEcoLinesForParent(lineToDelete.uniq);
                }
                
                this.lines.splice(index, 1)
                if (this.lines.length == 0) {
                    this.addRow()
                }

                this.computeUnderTotalLine();
            },
            checkIfNewRowNeeded: function (index) {
               if(this.editable){
                   if (this.lines.length > 0) {
                        if (this.lines.length - 1 == index) {
                            this.addRow()
                        }
                    }
               }
            },
            computeUnderTotalLine(event){
                var sum = 0;
                this.lines.forEach(line => {{
                    sum += parseFloat(line.total_ht)
                    if(line.is_title && line.under_total  && line.under_total != null){
                        line.under_total = sum;
                        line.designation = 'Sous total HT : ' + this.currency(sum)
                        sum = 0;
                    }
                }})
            },
            moveLine(){
                var sum = 0;
                setTimeout(() => {
                      this.lines.forEach((line,index) => {{
                        sum += parseFloat(line.total_after_discount)
                        if(line.is_title && line.under_total != null){
                            line.under_total = sum;
                            line.designation = 'Sous total HT : ' + this.currency(sum)
                            sum = 0;
                            if(line.under_total == 0){
                                this.lines.splice(index , 1);
                            }   
                        }
                        
                    }})
                }, 100);
              
            },
            getLines: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(line => {
                        this.addRow(line)
                    })
                    if(this.editable){
                        this.addRow(null)
                    }
                        
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
            // Méthodes de gestion des lignes éco-participation
            addEcoLine(ecoLine) {
                // Trouver l'index de la ligne parent
                const parentIndex = this.lines.findIndex(l => l.uniq === ecoLine.parent_uniq || (ecoLine.parent_id && l.id === ecoLine.parent_id));
                
                if (parentIndex !== -1) {
                    const parentLine = this.lines[parentIndex];
                    ecoLine.eco_parent_line_id = parentLine && parentLine.id ? parentLine.id : (ecoLine.eco_parent_line_id || null);
                    ecoLine.eco_parent_uniq = parentLine ? parentLine.uniq : (ecoLine.eco_parent_uniq || ecoLine.parent_uniq || null);
                    this.$set(ecoLine, 'is_optional', !!(parentLine && parentLine.is_optional));

                    // Calculer les totaux de la ligne éco
                    this.recomputeEcoLine(ecoLine, ecoLine.quantity, ecoLine.quantity);
                    
                    // Insérer la ligne éco juste après la ligne parent
                    this.lines.splice(parentIndex + 1, 0, ecoLine);
                }
            },
            removeEcoLinesForParent(parentUniq) {
                const parentLine = this.lines.find(line => line.uniq === parentUniq);
                const parentId = parentLine ? parentLine.id : null;
                // Supprimer toutes les lignes éco liées à ce parent
                this.lines = this.lines.filter(line => 
                    !(line.is_eco_participation && (
                        line.eco_parent_uniq === parentUniq ||
                        (parentId && line.eco_parent_line_id === parentId) ||
                        line.parent_uniq === parentUniq ||
                        (parentId && line.parent_id === parentId)
                    ))
                );
            },
            /** Une ligne passe en option ou en revient, avec son éco-participation. */
            toggleLineOptional(parentLine) {
                const isOptional = !parentLine.is_optional;
                this.$set(parentLine, 'is_optional', isOptional);

                this.lines.forEach(line => {
                    if (line.is_eco_participation && (
                        line.eco_parent_uniq === parentLine.uniq ||
                        (parentLine.id && line.eco_parent_line_id === parentLine.id)
                    )) {
                        this.$set(line, 'is_optional', isOptional);
                    }
                });
            },
            removeEcoLinesForArticle(articleUniq) {
                this.removeEcoLinesForParent(articleUniq);
            },
            updateEcoLinesQuantity({parentUniq, newQuantity, oldQuantity}) {
                const parentLine = this.lines.find(line => line.uniq === parentUniq);
                const parentId = parentLine ? parentLine.id : null;
                
                // Trouver toutes les lignes éco liées à ce parent
                this.lines.forEach(line => {
                    if (line.is_eco_participation && (
                        line.eco_parent_uniq === parentUniq ||
                        (parentId && line.eco_parent_line_id === parentId) ||
                        line.parent_uniq === parentUniq ||
                        (parentId && line.parent_id === parentId)
                    )) {
                        this.recomputeEcoLine(line, newQuantity, oldQuantity);
                    }
                });
            },
            getEcoUnitAmount(line, oldQuantity) {
                const explicitUnitAmount = parseFloat(line.eco_unit_amount);
                if (Number.isFinite(explicitUnitAmount)) {
                    return explicitUnitAmount;
                }

                const currentAmount = parseFloat(line.amount);
                if (Number.isFinite(currentAmount)) {
                    return parseFloat(currentAmount.toFixed(4));
                }

                const fallbackRateAmount = parseFloat(line.eco_rate_amount);
                if (Number.isFinite(fallbackRateAmount)) {
                    return fallbackRateAmount;
                }

                return 0;
            },
            recomputeEcoLine(line, parentQuantity, oldQuantity) {
                const nextQuantity = parseFloat(parentQuantity) || 0;
                const unitAmount = this.getEcoUnitAmount(line, oldQuantity);

                line.eco_unit_amount = unitAmount;
                line.amount = unitAmount;
                line.quantity = nextQuantity;
                line.total_ht = parseFloat((line.quantity * line.amount).toFixed(4));
                line.total_discount = 0;
                line.total_after_discount = line.total_ht;
                line.total_vat = parseFloat((line.total_after_discount * ((parseFloat(line.vat) || 0) / 100)).toFixed(2));
                line.total_ttc = parseFloat((line.total_after_discount + line.total_vat).toFixed(2));

                if (this.model == 'creditnote') {
                    line.total_ht = line.total_ht * -1;
                    line.total_after_discount = line.total_after_discount * -1;
                    line.total_vat = line.total_vat * -1;
                    line.total_ttc = line.total_ttc * -1;
                }
            }
        },
        mounted(){
            this.editable = this.isEditable;
            this.isAutoliquidation = this.oldAutoliquidation
            this.discount = this.oldDiscount

            const jsonLineBackup = JSON.parse(this.oldLines)
            if (Array.isArray(jsonLineBackup)) {
                if (jsonLineBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonLineBackup.forEach(line => {
                        this.addRow(line)
                    })
                }
                this.loading = false
            } else {
                this.getLines(jsonLineBackup)
            }

            if($('#company_id').length > 0){
                const self = this;
                $('#company_id').on('change', function () {
                    setTimeout(() => {
                        if($('#default_vat').length > 0 && $('#default_vat').val() != ""){
                            self.globalTva = $('#default_vat').val();
                        } else {
                            self.globalTva = self.tvaGlobal;
                        }
                    }, 1000)
                })
            }
        }
    }
</script>


